/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toTalkTemplateProps, toTalkTemplateRequest } from './translator/talkTemplate'
import {
  FetchTalkTemplate,
  PostTalkTemplate,
  PutTalkTemplate,
  DeleteTalkTemplate,
  SortTalkTemplate
} from '@/infrastructure/network/Monitaro/requests/talk_template'
import { ITalkTemplateProps } from '@/entities/TalkTemplate'

export default class TalkTemplate extends MonitaroGatewayBase {
  async FetchTalkTemplate() {
    const { templates } = await this.apiClient.request(new FetchTalkTemplate())
    return templates.map((prop) => toTalkTemplateProps(prop))
  }

  async PostTalkTemplate(params: ITalkTemplateProps) {
    const { template } = await this.apiClient.request(new PostTalkTemplate(toTalkTemplateRequest(params)))
    return toTalkTemplateProps(template)
  }

  async PutTalkTemplate(id: string, params: ITalkTemplateProps) {
    const { template } = await this.apiClient.request(new PutTalkTemplate(id, toTalkTemplateRequest(params)))
    return toTalkTemplateProps(template)
  }

  async DeleteTalkTemplate(id: string) {
    const { template } = await this.apiClient.request(new DeleteTalkTemplate(id))
    return toTalkTemplateProps(template)
  }

  async SortTalkTemplate(ids: string[]) {
    const { templates } = await this.apiClient.request(new SortTalkTemplate({ ids }))
    return templates.map((prop) => toTalkTemplateProps(prop))
  }
}
